/**
 * Российский мобильный: после кода страны 7 первая цифра абонента — 9.
 * Допустимы ввод 8… / 7… / 9… (10 цифр без кода страны).
 */

const MOBILE_HINT = 'Введите мобильный номер в формате +7 (9XX) XXX-XX-XX';

/** @returns {string|null} 11 цифр вида 79XXXXXXXXX или null */
export function getRussianMobileDigits11(phone) {
  const d = String(phone || '').replace(/\D/g, '');
  if (d.length === 11 && (d[0] === '7' || d[0] === '8')) {
    return d[0] === '8' ? `7${d.slice(1)}` : d;
  }
  if (d.length === 10 && d[0] === '9') {
    return `7${d}`;
  }
  return null;
}

export function isValidRussianMobilePhone(phone) {
  const n = getRussianMobileDigits11(phone);
  return Boolean(n && n.length === 11 && /^79\d{9}$/.test(n));
}

/** +79161234567 при валидном номере, иначе пустая строка */
export function formatRussianMobileE164(phone) {
  return isValidRussianMobilePhone(phone) ? `+${getRussianMobileDigits11(phone)}` : '';
}

export function russianMobilePhoneHint() {
  return MOBILE_HINT;
}
